(function () {
  // Bundle slider — shows the other kids products in the cart drawer.
  // The discount itself is applied by two Shopify automatic discounts
  // ("Bundle & Save" and "Bundle & Save (Climbing Wall)"). This script only
  // shows the offer and adds the item to the cart.
  var cfgEl = document.getElementById("bundle-slider-config");
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG.enabled || !CFG.groups) return;

  var SAVE = CFG.saveCents;
  var groupOf = {};          // product id -> group key
  Object.keys(CFG.groups).forEach(function (key) {
    CFG.groups[key].detectIds.forEach(function (id) { groupOf[String(id)] = key; });
  });

  var state = { present: {}, kind: "preorder" };
  var towerColour = null;
  var slider = null;

  // ── helpers ────────────────────────────────────────────────────────────
  function money(cents) {
    var fmt = CFG.moneyFormat || "${{amount}}";
    var amount = (cents / 100).toFixed(2);
    if (amount.slice(-3) === ".00") amount = amount.slice(0, -3);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); });
  }

  function addItem(variantId) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
  }

  function kindOfVariant(variantId) {
    var kind = null;
    Object.keys(CFG.groups).forEach(function (key) {
      CFG.groups[key].options.forEach(function (o) {
        o.variants.forEach(function (v) { if (String(v.id) === String(variantId)) kind = v.kind; });
      });
    });
    return kind;
  }

  function hasBothKinds(key) {
    var seen = {};
    CFG.groups[key].options.forEach(function (o) {
      o.variants.forEach(function (v) { seen[v.kind] = true; });
    });
    return seen.preorder && seen.instock;
  }

  // Pick the variant that matches the cart's delivery type (pre-order vs ship
  // now) so the order doesn't end up half pre-order. Falls back to whatever
  // is available.
  function pickVariant(option) {
    var match = null, fallback = null;
    option.variants.forEach(function (v) {
      if (!v.available) return;
      if (!fallback) fallback = v;
      if (!match && v.kind === state.kind) match = v;
    });
    return match || fallback;
  }

  function optionFor(key) {
    var g = CFG.groups[key];
    if (key === "tower" && g.options.length > 1) {
      var found = null;
      g.options.forEach(function (o) { if (o.label === towerColour) found = o; });
      if (!found || !pickVariant(found)) {
        found = null;
        g.options.forEach(function (o) { if (!found && pickVariant(o)) found = o; });
      }
      if (found) towerColour = found.label;
      return found;
    }
    var first = null;
    g.options.forEach(function (o) { if (!first && pickVariant(o)) first = o; });
    return first;
  }

  // ── rendering ──────────────────────────────────────────────────────────
  function missingGroups() {
    return Object.keys(CFG.groups).filter(function (k) { return !state.present[k]; });
  }

  function presentCount() {
    return Object.keys(CFG.groups).filter(function (k) { return state.present[k]; }).length;
  }

  function cardHtml(key) {
    var g = CFG.groups[key];
    var opt = optionFor(key);
    if (!opt) return "";
    var v = pickVariant(opt);
    var chips = "";
    if (key === "tower" && g.options.length > 1) {
      chips = '<div class="bs-chips">' + g.options.filter(function (o) { return pickVariant(o); }).map(function (o) {
        return '<button type="button" class="bs-chip' + (o.label === towerColour ? " bs-sel" : "") +
          '" data-colour="' + o.label + '"><img src="' + o.image + '" alt="">' + o.label + "</button>";
      }).join("") + "</div>";
    }
    return '<div class="bs-card" data-group="' + key + '">' +
      '<a class="bs-img" href="' + g.url + '"><img src="' + opt.image + '" alt="' + g.title + '" loading="lazy"></a>' +
      '<div class="bs-info">' +
        '<a class="bs-title" href="' + g.url + '">' + g.title + "</a>" +
        (g.blurb ? '<div class="bs-blurb">' + g.blurb + "</div>" : "") +
        '<div class="bs-price"><s>' + money(v.price) + "</s> <b>" + money(v.price - SAVE) + "</b></div>" +
        chips +
        '<button type="button" class="bs-add" data-variant="' + v.id + '">Add &amp; save ' + money(SAVE) + "</button>" +
      "</div></div>";
  }

  // Sit just above the Shipping Protection box when it's there, otherwise at
  // the end of the cart items.
  function place(content) {
    var sp = content.querySelector("#sp-toggle-widget");
    if (sp) {
      if (slider.nextElementSibling !== sp) sp.parentNode.insertBefore(slider, sp);
    } else if (slider.parentNode !== content) {
      content.appendChild(slider);
    }
  }

  function render() {
    var content = document.querySelector("#Cart-Drawer .side-panel-content");
    var count = presentCount();
    var missing = missingGroups();

    if (!content || count === 0 || missing.length === 0) {
      if (slider) {
        slider.innerHTML = "";
        if (slider.parentNode) slider.parentNode.removeChild(slider);
      }
      return;
    }

    if (!slider) {
      slider = document.createElement("div");
      slider.className = "bs-wrap";
      slider.addEventListener("click", onClick);
    }

    var hl = function (s) { return '<span class="bs-hl">' + s + "</span>"; };
    var heading = count === 1
      ? "Bundle &amp; save " + hl(money(SAVE)) + " on each extra"
      : "Complete the set &mdash; save another " + hl(money(SAVE));
    var sub = count === 1
      ? "Add another kids piece to this order. Buy all 3 and save <b>" + money(SAVE * 2) + "</b>."
      : "Add the last piece and save <b>" + money(SAVE * 2) + "</b> in total.";

    var cards = missing.map(cardHtml).join("");
    var multi = missing.length > 1;

    slider.innerHTML =
      '<div class="bs-head"><div class="bs-h">' + heading + '</div><div class="bs-sub">' + sub + "</div></div>" +
      '<div class="bs-track' + (multi ? " bs-multi" : "") + '">' + cards + "</div>" +
      (multi
        ? '<div class="bs-nav"><button type="button" class="bs-prev" aria-label="Previous">&#8249;</button>' +
          '<div class="bs-dots">' + missing.map(function (_, i) {
            return '<span class="bs-dot' + (i === 0 ? " bs-on" : "") + '"></span>';
          }).join("") + "</div>" +
          '<button type="button" class="bs-next" aria-label="Next">&#8250;</button></div>'
        : "");

    place(content);

    var track = slider.querySelector(".bs-track");
    if (multi && track) {
      track.addEventListener("scroll", function () {
        var w = track.firstElementChild ? track.firstElementChild.offsetWidth : 1;
        var i = Math.round(track.scrollLeft / w);
        Array.prototype.forEach.call(slider.querySelectorAll(".bs-dot"), function (d, n) {
          d.classList.toggle("bs-on", n === i);
        });
      }, { passive: true });
    }
  }

  function onClick(e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;

    var chip = t.closest(".bs-chip");
    if (chip) {
      e.preventDefault();
      towerColour = chip.dataset.colour;
      render();
      return;
    }

    var nav = t.closest(".bs-prev, .bs-next");
    if (nav) {
      e.preventDefault();
      var track = slider.querySelector(".bs-track");
      var w = track.firstElementChild ? track.firstElementChild.offsetWidth + 10 : 200;
      track.scrollBy({ left: nav.classList.contains("bs-next") ? w : -w, behavior: "smooth" });
      return;
    }

    var add = t.closest(".bs-add");
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      add.textContent = "Adding…";
      addItem(add.dataset.variant)
        .catch(function () {})
        .then(function () {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          if (window.PUB_SUB_EVENTS && window.publish) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, {}); } catch (err) {}
          }
        });
    }
  }

  // ── keep in sync with the cart ─────────────────────────────────────────
  function reconcile() {
    return getCart().then(function (cart) {
      state.present = {};
      var kind = null;
      cart.items.forEach(function (item) {
        var key = groupOf[String(item.product_id)];
        if (!key) return;
        state.present[key] = true;
        // Only follow the delivery type of products that offer both
        // (pre-order and ship-now). The Pikler set has one option only, so it
        // shouldn't push the others to their pricier ship-now version.
        if (!hasBothKinds(key)) return;
        var k = kindOfVariant(item.variant_id);
        if (!kind && k) kind = k;
      });
      state.kind = kind || "preorder";

      // The free busy board is only for tower orders. Its discount can't check
      // for a tower itself, so take it out of any cart that has no tower.
      if (!state.present.tower && CFG.towerGiftVariantIds) {
        var strays = {};
        cart.items.forEach(function (item) {
          if (CFG.towerGiftVariantIds.indexOf(item.variant_id) > -1) strays[item.variant_id] = 0;
        });
        if (Object.keys(strays).length) {
          return fetch("/cart/update.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: strays })
          }).then(function () {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          });
        }
      }
      render();
    }).catch(function () {});
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 350);
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ""));
  }

  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input || {}).url;
    var p = _fetch.apply(window, arguments);
    if (isCartMutation(url)) p.then(schedule, schedule);
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this._bsWatch = isCartMutation(url);
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._bsWatch) this.addEventListener("loadend", schedule);
    return _send.apply(this, arguments);
  };

  // The drawer re-draws itself on every change, which wipes the slider out —
  // put it back once the theme is done.
  ["cart:refresh", "cart:updated", "cart-drawer:open"].forEach(function (evt) {
    document.addEventListener(evt, schedule);
  });

  // Safety net: if the drawer re-draws after we've rendered (slow network),
  // put the slider straight back.
  function watchDrawer() {
    var drawer = document.getElementById("Cart-Drawer");
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!slider || !slider.innerHTML) return;
      if (!document.body.contains(slider)) { render(); return; }
      // Shipping Protection adds itself a moment later — keep the slider above it
      var content = document.querySelector("#Cart-Drawer .side-panel-content");
      if (content) place(content);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function start() {
    watchDrawer();
    reconcile();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();